<div class="dropdown">
  <div class="dropdowncd overflow-hidden shadow-2xl">

    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="flex justify-center items-center h-full w-full my-3">
      <mat-spinner [diameter]="40"></mat-spinner>
    </div>

    <!-- Content to show when not loading -->
    <div *ngIf="!isLoading" class="p-4 text-center hover:bg-hover trans-ease-out cursor-pointer relative" matRipple>
      <div class="mx-auto relative" style="width: fit-content;">
        <button (click)="onEdit(data)" class="absolute bottom-1 right-1 cursor-pointer appearance-none bg-transparent border-none focus:outline-none rounded-full p-1 qqmeTxt h-6 w-6 flex justify-center items-center" matTooltip="Update profile image" matTooltipPosition="left">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 10 10" fill="none">
            <path d="M0 10H2.08304L8.22664 3.85641L6.14359 1.77336L0 7.91696V10ZM1.11096 8.378L6.14359 3.34537L6.65463 3.85641L1.622 8.88904H1.11096V8.378Z" fill="white"/>
            <path d="M8.5377 0.162477C8.32107 -0.0541591 7.97111 -0.0541591 7.75448 0.162477L6.73795 1.179L8.821 3.26205L9.83752 2.24552C10.0542 2.02888 10.0542 1.67893 9.83752 1.4623L8.5377 0.162477Z" fill="white"/>
          </svg>
        </button>
        <img
          [src]="(data?.profile_image && data.profile_image !== 'null' && data.profile_image !== null && data.profile_image !== '') ? data.profile_image : '/assets/user.png'"
          class="avatar h-24 w-24 mx-auto">
      </div>

      <div class="body-2 text-role">
        <span>{{data?.roleName | titlecase}}</span>
      </div>

      <h2 class="title mb-0 mt-3">{{data?.name}}</h2>

      <div class="body-2 text-role" *ngIf="data?.email && data.email !== 'null' && data.email !== null">
        <span>{{data?.email}}</span>
      </div>
    </div>

    <!-- Office phone section -->
    <div class="dropdowncl px-2 py-5" fxLayout="row" fxLayoutAlign="space-around start" *ngIf="!isLoading">
      <div *ngIf="data?.officePhone && data.officePhone !== 'null' && data.officePhone !== null" class="body-2">
        <ic-icon [icon]="icPhone" class="ltr:mr-2 rtl:ml-1 icon-bg text-base" inline="true"></ic-icon>
        <span class="office-phone font-medium ltr:mr-2">Office phone</span>
        <span class="text-black">{{ data?.officePhone }}</span>
      </div>
    </div>

    <!-- Role selection section -->
    <div class="py-2 pb-5 px-2 bg-white flex justify-around items-center" *ngIf="!isLoading">
      <button mat-button [matMenuTriggerFor]="roleMenu" class="settings" matTooltip="Switch to role">
        <mat-icon>verified_user</mat-icon>
        {{ roleName | titlecase }}
        <mat-icon [icIcon]="icArrowDropDown"></mat-icon>
      </button>
      <mat-menu #roleMenu="matMenu">
        <button mat-menu-item *ngFor="let role of data.roles" (click)="setRole(role.roleName)" class="flex items-center justify-between w-full" [matTooltip]="role.roleName === roleName ? null : 'Switch to ' + (role.roleName | titlecase)">
          <span>{{ role.roleName | titlecase }}</span>
          <mat-icon *ngIf="role.roleName === roleName" class="text_bg_design ml-2">check_circle</mat-icon>
        </button>
      </mat-menu>
    </div>

    <!-- Settings and Sign out -->
    <div class="py-2 pb-5 px-2 bg-white flex justify-around items-center" *ngIf="!isLoading">
      <button (click)="close()" [routerLink]="'/admin'" mat-icon-button type="button" matTooltip="Settings" class="settings block w-14 px-2">
        <mat-icon>settings</mat-icon>
        Settings
      </button>
      <a class="block w-14 px-2"  (click)="onLogout()" style="color:var(--app-accent) !important" mat-button>Sign out</a>
    </div>

  </div>
</div>

<!-- Settings Menu -->
<mat-menu #settingsMenu="matMenu" xPosition="before" yPosition="below">
  <button (click)="close()" routerLink="/admin/change-password" mat-menu-item>
    <mat-icon [icIcon]="icLock"></mat-icon>
    <span>Change Password</span>
  </button>
</mat-menu>
